import MapButton from './parts/MapButton'
import OrdersTabBadge from './parts/OrdersTabBadge'
import LayoutWrapper from '@/features/orders/components/Tabs/parts/LayoutWrapper'
import TopTabs from '@/features/ui/components/TopTabs'
import { Tab } from '@/features/ui/navigation'
import { useScreenLayout } from '@/hooks/screen'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'

interface TabsProps {
    onMapOpen: () => void
}

const Tabs: FC<TabsProps> = ({ onMapOpen }) => {
    const { t } = useTranslation()
    const layout = useScreenLayout()

    return (
        <View style={{ flex: 1 }}>
            <TopTabs
                layout={({ children }) => <LayoutWrapper>{children}</LayoutWrapper>}
                screenOptions={{ swipeEnabled: true }}
            >
                <TopTabs.Screen
                    name="index"
                    options={{
                        tabBarLabel: ({ focused }) => (
                            <Tab active={focused} Badge={OrdersTabBadge}>
                                {t('ordersTabs.all')}
                            </Tab>
                        ),
                    }}
                />
            </TopTabs>
            {layout === 'compact' && (
                <View style={{ position: 'absolute', top: 10, right: 16 }}>
                    <MapButton onPress={onMapOpen} accessibilityLabel={t('ordersMap.open')} />
                </View>
            )}
        </View>
    )
}

export default Tabs
